module.exports = __webpack_public_path__ + "media/images/social-icon-1-60bb881a448134de82a6b30786ab70bd.png";